import { render, staticRenderFns } from "./ComBlocks.vue?vue&type=template&id=dfe7c658&scoped=true&"
import script from "./ComBlocks.vue?vue&type=script&lang=js&"
export * from "./ComBlocks.vue?vue&type=script&lang=js&"
import style0 from "./ComBlocks.vue?vue&type=style&index=0&id=dfe7c658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe7c658",
  null
  
)

export default component.exports